<template>
  <v-container fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="triggerData"
        :options.sync="options"
        item-key="id"
        :search="search"
        :footer-props="footerProps"
        :loading-text="$t('trigger.triggersLoading')"
        :no-data-text="$t('trigger.noTriggers')"
        mobile-breakpoint="768"
        :loading="loadingData"
        :server-items-length="totalTriggers"
        dense
        :header-props="headerProps"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" outlined :to="'/triggers/add'"><v-icon>mdi-plus</v-icon></v-btn>
            <v-badge overlap :value="nbActiveFilters" :content="nbActiveFilters">
              <v-btn color="primary" outlined class="ml-2" @click="displayFilters = !displayFilters">
                <v-icon>mdi-filter-plus-outline</v-icon>
              </v-btn>
            </v-badge>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined class="mb-2" @click="reloadList()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            :class="[$vuetify.breakpoint.width >= 768 ? '' : 'pr-0']"
            text
            color="primary"
            @click="executeAction(item._id)"
          >
            <v-icon v-if="$vuetify.breakpoint.width > 767 && $vuetify.breakpoint.width < 1264" color="primary">
              mdi-magnify
            </v-icon>
            <span v-else>{{ $t('trigger.detail') }}</span>
          </v-btn>
        </template>

        <template v-slot:item.active="{ item }">
          <v-switch v-model="item.active" @change="openActivationModal(item)" :loading="loadingData" />
        </template>

        <template v-slot:item.event="{ item }">
          {{ getEventTranslation(item.event) }}
        </template>
      </v-data-table>
      <filter-dialog
        :key="formFiltersKey"
        v-model="displayFilters"
        :title="$t('trigger.filterTriggers')"
        :fields="headers"
        @confirm="filter"
        :loadingData="loadingData"
      />
      <activation-dialog
        v-model="triggerActivationDialog"
        :title="modalTitle"
        :text="modalText"
        :loading="loadingData"
        @yes="updateTrigger"
        @no="revertTriggerActive"
      />
    </v-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import confirmationDialog from '../../components/ConfirmationDialog.vue'
  import { EventBus } from '../../event-bus'

  export default {
    name: 'TriggersTable',
    components: {
      activationDialog: confirmationDialog,
    },
    data() {
      return {
        search: '',
        triggerData: [],
        options: {
          itemsPerPage: 15,
          sortDesc: [],
        },
        loadingData: false,
        totalTriggers: 0,
        filters: [],
        displayFilters: false,
        triggerActivationDialog: false,
        targetItem: undefined,
        modalTitle: '',
        modalText: '',
        formFiltersKey: Date.now(),
      }
    },
    methods: {
      executeAction: function (triggerId) {
        this.$router.push('/triggers/' + triggerId)
      },
      async reloadList() {
        await this.$auth.isAuthenticated()
        EventBus.$emit('reLoadCounter')
        this.options.page = 1
        this.list()
      },
      filter(filters) {
        this.filters = filters
        this.reloadList()
      },
      list() {
        this.loadingData = true
        let { page, itemsPerPage, sortDesc, sortBy } = this.options

        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            page: page,
            items_per_page: itemsPerPage,
            sort_by: sortBy.length === 0 ? undefined : sortBy,
            sort_desc: sortDesc.length === 0 ? true : sortDesc,
          },
        }
        for (let filter of this.filters) {
          if (filter.active) {
            myInit.queryStringParameters[filter.name] = filter.value
          }
        }
        this.$Amplify.API.get('triggers', '/v1/int/triggers', myInit)
          .then((res) => {
            this.triggerData = res.data
            this.totalTriggers = res.nbTriggers
            if (this.totalTriggers < (this.options.page - 1) * this.options.itemsPerPage + 1) {
              let pageNumber = Math.floor(this.totalTriggers / this.options.itemsPerPage)
              this.options.page = pageNumber === 0 ? 1 : pageNumber
            }
            this.loadingData = false
          })
          .catch((e) => {
            this.loadingData = false
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('trigger.errorTriggersLoading'),
              color: 'error',
            })
          })
      },
      openActivationModal(item) {
        this.targetItem = item
        this.modalTitle = item.active
          ? this.$t('trigger.activateTriggerModalTitle')
          : this.$t('trigger.deactivateTriggerModalTitle')
        this.modalText = item.active
          ? this.$t('trigger.activateTriggerModalText')
          : this.$t('trigger.deactivateTriggerModalText')
        this.triggerActivationDialog = true
      },
      revertTriggerActive() {
        this.targetItem.active = !this.targetItem.active
        this.targetItem = undefined
        this.triggerActivationDialog = false
      },
      updateTrigger() {
        this.loadingData = true
        let triggerCopy = JSON.parse(JSON.stringify(this.targetItem))

        let path = '/v1/int/triggers/' + this.targetItem._id
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: triggerCopy,
        }
        this.$Amplify.API.put('triggers', path, myInit)
          .then(() => {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('trigger.triggerUpdated'),
              color: 'success',
            })
          })
          .catch((e) => {
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('trigger.errorTriggerUpdate'),
              color: 'error',
            })
            console.log(e)
            this.targetItem.active = !this.targetItem.active
          })
          .finally(() => {
            this.targetItem = undefined
            this.triggerActivationDialog = false
            this.loadingData = false
          })
      },
      getEventTranslation(eventName) {
        const event = this.events.find((event) => event.value === eventName)
        return event ? event.text : eventName
      },
    },
    watch: {
      options: {
        handler() {
          this.list()
        },
      },
    },
    computed: {
      ...mapState(['currentStore', 'isCustomerService', 'roleRights']),

      nbActiveFilters() {
        return this.filters.filter((filter) => filter.active).length
      },
      footerProps() {
        return {
          'items-per-page-options': [15, 30, 50],
          'items-per-page-text': this.$t('trigger.triggersPerPage'),
        }
      },
      headerProps() {
        return {
          sortByText: this.$t('trigger.sortByText'),
        }
      },
      events() {
        return [
          {
            text: this.$t('trigger.createOrder'),
            value: 'createOrder',
          },
          {
            text: this.$t('trigger.createSubOrder'),
            value: 'createSubOrder',
          },
          {
            text: this.$t('trigger.updateOrderStatus'),
            value: 'updateOrderStatus',
          },
          {
            text: this.$t('trigger.updateSubOrderStatus'),
            value: 'updateSubOrderStatus',
          },
          {
            text: this.$t('trigger.updateOrder'),
            value: 'updateOrder',
          },
          {
            text: this.$t('trigger.updateSubOrder'),
            value: 'updateSubOrder',
          },
          {
            text: this.$t('trigger.createSlipOrder'),
            value: 'createSlipOrder',
          },
          {
            text: this.$t('trigger.createReturn'),
            value: 'createReturn',
          },
          {
            text: this.$t('trigger.updateReturnStatus'),
            value: 'updateReturnStatus',
          },
          {
            text: this.$t('trigger.getTransaction'),
            value: 'getTransaction',
          },
          {
            text: this.$t('trigger.listTransactions'),
            value: 'listTransactions',
          },
          {
            text: this.$t('trigger.createReturnLabel'),
            value: 'createReturnLabel',
          },
          {
            text: this.$t('trigger.updateReturn'),
            value: 'updateReturn',
          },
          {
            text: this.$t('trigger.createRefund'),
            value: 'createRefund',
          },
          {
            text: this.$t('trigger.updateRefund'),
            value: 'updateRefund',
          },
          {
            text: this.$t('trigger.createStockTransfer'),
            value: 'createStockTransfer',
          },
          {
            text: this.$t('trigger.updateStockTransfer'),
            value: 'updateStockTransfer',
          },
          {
            text: this.$t('trigger.resendPickupCode'),
            value: 'resendPickupCode',
          },
          {
            text: this.$t('trigger.createLocation'),
            value: 'createLocation',
          },
          {
            text: this.$t('trigger.updateLocation'),
            value: 'updateLocation',
          },
          {
            text: this.$t('trigger.deleteLocation'),
            value: 'deleteLocation',
          },
          {
            text: this.$t('trigger.createStockParsing'),
            value: 'createStockParsing',
          },
          {
            text: this.$t('trigger.updateStockParsing'),
            value: 'updateStockParsing',
          },
        ]
      },
      headers() {
        return [
          {
            text: this.$t('trigger.reference'),
            value: '_id',
            filterType: 'text',
          },
          {
            text: this.$t('trigger.name'),
            value: 'name',
            filterType: 'text',
          },
          {
            text: this.$t('trigger.event'),
            value: 'event',
            filterType: 'array',
            arrayValues: this.events,
          },
          {
            text: this.$t('trigger.active'),
            value: 'active',
            filterType: 'array',
            multiple: false,
            clearable: true,
            arrayValues: [
              {
                text: 'true',
                value: 'true',
              },
              {
                text: 'false',
                value: 'false',
              },
            ],
          },
          {
            text: '',
            value: 'action',
            sortable: false,
          },
        ]
      },
    },
    activated() {
      let previousPath = this.$store.state.previousPath.split('/')[1]
      // we reset filters if the previous page wasn't the details of a trigger
      if (previousPath !== 'triggers') {
        this.filters = []
        this.formFiltersKey = Date.now()
        this.options.page = 1
        this.options.itemsPerPage = 15
        this.options.sortBy = []
        this.options.sortDesc = []
      }
      this.triggerData = []
      this.list()
    },
  }
</script>
